// සුවඩි Activity History Panel - Modular Activity Tracker
import React from 'react';
import { WarrantyIcon } from './WarrantyIcon';
import type { ActivityHistoryPanelProps } from './types';

export const ActivityHistoryPanel: React.FC<ActivityHistoryPanelProps> = ({ 
  isOpen, 
  onClose, 
  activities 
}) => {
  if (!isOpen) return null;

  const getActivityIcon = (type: string) => {
    switch (type) {
      case 'warranty_added': return 'warranty-shield';
      case 'ai_processed': return 'brain';
      case 'document_uploaded': return 'upload-cloud';
      case 'voice_input': return 'mic';
      default: return 'clock';
    }
  };

  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'success': return 'star';
      case 'pending': return 'clock';
      case 'error': return 'star';
      default: return 'clock';
    }
  };

  return (
    <>
      {/* Overlay to close on click outside */}
      <div 
        className="warranty-activity-overlay"
        onClick={onClose}
        role="presentation"
        aria-hidden="true"
      />
      
      <aside 
        className="warranty-activity-panel"
        role="complementary"
        aria-labelledby="activity-panel-title"
      >
        <div className="warranty-activity-header">
          <h4 id="activity-panel-title">
            <WarrantyIcon name="clock" />
            Recent Activity
          </h4>
          <button 
            onClick={onClose} 
            className="warranty-activity-close"
            aria-label="Close activity panel"
          >
            ×
          </button>
        </div>
        
        <div className="warranty-activity-list" role="log" aria-live="polite">
          {activities.length === 0 ? (
            <div className="warranty-activity-empty" role="status">
              <WarrantyIcon name="clock" className="warranty-empty-icon" />
              <p>No recent activity</p>
            </div>
          ) : (
            activities.map((activity) => (
              <div 
                key={activity.id} 
                className={`warranty-activity-item warranty-activity-${activity.status}`}
                role="listitem"
              >
                <div className="warranty-activity-icon" aria-hidden="true">
                  <WarrantyIcon name={getActivityIcon(activity.type)} />
                </div>
                <div className="warranty-activity-content">
                  <div className="warranty-activity-details">
                    {activity.details}
                  </div>
                  <div className="warranty-activity-time">
                    <time dateTime={activity.timestamp.toISOString()}>
                      {activity.timestamp.toLocaleTimeString()}
                    </time>
                  </div>
                </div>
                <div 
                  className={`warranty-activity-status warranty-status-${activity.status}`}
                  aria-label={`Status: ${activity.status}`}
                >
                  <WarrantyIcon name={getStatusIcon(activity.status)} />
                </div>
              </div>
            ))
          )}
        </div>
      </aside>
    </>
  );
};

export default ActivityHistoryPanel;
